export enum ButtonStyle {
	default = "default",
	orange = "orange",
	underline = "underline",
	transparent = "transparent",
	transparentInverse = "transparentInverse",
	git = "git",
	purple = "purple",
}
